import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseDashboardProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseDashboard: React.FunctionComponent<React.PropsWithChildren<NewReleaseDashboardProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseDashboardProps) => (
    <SVGBase viewBox="0 0 49.95 49.95" height={height} width={width} title={title} fill={fill} {...rest}>
        <path fill="#fff5cc" d="M8.86,19.84h34a1.26,1.26,0,0,1,1.27,1.26v7h4.62A1.25,1.25,0,0,0,50,26.82V5.39H8.86Z" />
        <path
            fill="#ffd940"
            d="M48.77,0H10A1.18,1.18,0,0,0,8.86,1.18V5.39H50V1.18A1.18,1.18,0,0,0,48.77,0ZM11.65,3.68a1,1,0,1,1,1-1A1,1,0,0,1,11.65,3.68Zm3.26,0a1,1,0,1,1,1-1A1,1,0,0,1,14.91,3.68Zm3.27,0a1,1,0,1,1,1-1A1,1,0,0,1,18.18,3.68Z"
        />
        <path fill="#fdf4cf" d="M11.65,1.71a1,1,0,1,0,1,1A1,1,0,0,0,11.65,1.71Z" />
        <path fill="#fdf4cf" d="M14.91,1.71a1,1,0,1,0,1,1A1,1,0,0,0,14.91,1.71Z" />
        <path fill="#fdf4cf" d="M18.18,1.71a1,1,0,1,0,1,1A1,1,0,0,0,18.18,1.71Z" />
        <path
            fill="#fdf4cf"
            d="M0,25.62v23A1.33,1.33,0,0,0,1.32,50H42.76a1.33,1.33,0,0,0,1.33-1.33v-23ZM20.88,46.17a.78.78,0,0,1-.78.78h-17a.78.78,0,0,1-.78-.78v-14a.78.78,0,0,1,.78-.78h17a.78.78,0,0,1,.78.78Zm20.86,0A.78.78,0,0,1,41,47H24a.78.78,0,0,1-.78-.78v-14a.78.78,0,0,1,.78-.78H41a.78.78,0,0,1,.78.78Z"
        />
        <path
            fill="#ffd940"
            d="M44.09,25.62V21.1a1.26,1.26,0,0,0-1.27-1.26H1.26A1.26,1.26,0,0,0,0,21.1v4.52ZM10,21.68A1.05,1.05,0,1,1,9,22.73,1,1,0,0,1,10,21.68Zm-7,2.1a1.05,1.05,0,1,1,1-1.05A1,1,0,0,1,3,23.78Zm3.5,0a1.05,1.05,0,1,1,1.06-1.05A1,1,0,0,1,6.49,23.78Z"
        />
        <circle fill="#fdf4cf" cx="2.99" cy="22.73" r="1.05" />
        <circle fill="#fdf4cf" cx="6.49" cy="22.73" r="1.05" />
        <circle fill="#fdf4cf" cx="10" cy="22.73" r="1.05" />
        <path
            fill="#fff"
            d="M20.1,31.43h-17a.78.78,0,0,0-.78.78v14a.78.78,0,0,0,.78.78h17a.78.78,0,0,0,.78-.78v-14A.78.78,0,0,0,20.1,31.43ZM9.59,44.67a.65.65,0,0,1-.66.66H7.16a.66.66,0,0,1-.67-.66v-3A.67.67,0,0,1,7.16,41H8.93a.66.66,0,0,1,.66.67ZM9,36.58H4.65a.61.61,0,0,1,0-1.21H9a.61.61,0,1,1,0,1.21Zm0-2.15H4.65a.61.61,0,0,1,0-1.21H9a.61.61,0,1,1,0,1.21Zm5.27,10.24a.66.66,0,0,1-.67.66H11.83a.66.66,0,0,1-.67-.66V39.29a.67.67,0,0,1,.67-.67h1.76a.67.67,0,0,1,.67.67Zm4.67,0a.66.66,0,0,1-.67.66H16.49a.65.65,0,0,1-.66-.66V35.74a.66.66,0,0,1,.66-.66h1.77a.67.67,0,0,1,.67.66Z"
        />
        <path fill="#fdf4cf" d="M9,33.22H4.65a.61.61,0,0,0,0,1.21H9a.61.61,0,1,0,0-1.21Z" />
        <path fill="#fdf4cf" d="M9,35.37H4.65a.61.61,0,0,0,0,1.21H9a.61.61,0,1,0,0-1.21Z" />
        <rect fill="#ffd940" x="6.49" y="40.99" width="3.1" height="4.34" rx="0.66" />
        <rect fill="#ffd940" x="11.16" y="38.62" width="3.1" height="6.71" rx="0.66" />
        <rect fill="#ffd940" x="15.83" y="35.08" width="3.1" height="10.26" rx="0.66" />
        <path
            fill="#fff"
            d="M41,31.43H24a.78.78,0,0,0-.78.78v14A.78.78,0,0,0,24,47H41a.78.78,0,0,0,.78-.78v-14A.78.78,0,0,0,41,31.43ZM25.51,33.22h6.36a.61.61,0,1,1,0,1.21H25.51a.61.61,0,0,1,0-1.21Zm3.43,3.36H25.51a.61.61,0,0,1,0-1.21h3.43a.61.61,0,1,1,0,1.21Zm10.23,6.75a4.48,4.48,0,0,1-4.09,2.05l.15-2h0l-.16,2A4.46,4.46,0,0,1,33,44.7l0,0a4.45,4.45,0,0,1-2-2.79l2-.43h0l-2,.43a4.49,4.49,0,0,1,3.44-5.37l.43,2h0l-.42-2a4.5,4.5,0,0,1,3.35.62l0,0a4.48,4.48,0,0,1,1.32,6.17l-1.69-1.09h0Z"
        />
        <path fill="#fdf4cf" d="M25.51,34.43h6.36a.61.61,0,1,0,0-1.21H25.51a.61.61,0,0,0,0,1.21Z" />
        <path fill="#fdf4cf" d="M28.94,35.37H25.51a.61.61,0,0,0,0,1.21h3.43a.61.61,0,1,0,0-1.21Z" />
        <path
            fill="#ffd940"
            d="M33,41.46l-2,.43a4.45,4.45,0,0,0,2,2.79l0,0a4.46,4.46,0,0,0,2.06.68l.16-2A2.47,2.47,0,0,1,33,41.46Z"
        />
        <path
            fill="#ffeb99"
            d="M35.4,43.39l-.17,0-.15,2a4.48,4.48,0,0,0,4.09-2.05l-1.69-1.08A2.49,2.49,0,0,1,35.4,43.39Z"
        />
        <path
            fill="#ffeb99"
            d="M34.89,38.48l-.43-2A4.49,4.49,0,0,0,31,41.89l2-.43a2.51,2.51,0,0,1-.07-.55A2.48,2.48,0,0,1,34.89,38.48Z"
        />
        <path
            fill="#ffd940"
            d="M37.88,40.91a2.42,2.42,0,0,1-.4,1.33l1.69,1.09a4.48,4.48,0,0,0-1.32-6.17l0,0a4.5,4.5,0,0,0-3.35-.62l.42,2a2.1,2.1,0,0,1,.51,0A2.48,2.48,0,0,1,37.88,40.91Z"
        />
        <path
            fill="#fff"
            d="M37.88,40.91a2.48,2.48,0,0,0-2.48-2.48,2.1,2.1,0,0,0-.51,0h0a2.48,2.48,0,0,0-2,2.43,2.51,2.51,0,0,0,.07.55h0a2.47,2.47,0,0,0,2.25,1.91h0l.17,0a2.49,2.49,0,0,0,2.08-1.14h0A2.42,2.42,0,0,0,37.88,40.91Z"
        />
    </SVGBase>
);

export default NewReleaseDashboard;
